import queryString from 'query-string'
import {WITH_AUTH_ADMIN_PATHS} from 'consts/paths'
import {Redirect} from 'react-router'

// 旧ストレスチェック開始画面
const StressCheckStart = ({location: {search}}) => {
  let params = {}

  const roleType = queryString.parse(search).role_type
  if (roleType) {
    params = {stress_check: true, stress_check_role: roleType}
  }

  return (
    <Redirect to={{pathname: WITH_AUTH_ADMIN_PATHS.HEALTHCARE_START.INDEX, search: queryString.stringify(params)}} />
  )
}

export default StressCheckStart
